/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-05.
 */
export const FLOATING_BUTTON_STYLE = { position: 'fixed', bottom: 30, right: 30, zIndex: 1 };
export const REFRESH_INDICATOR = { position: 'fixed', right: '50%', top: 85, zIndex: 1 };



// WEBPACK FOOTER //
// ./styles/index.js